/**
 * QuickImageSortPanel - Slide-Over for quick image sorting after file drop
 *
 * Opens when user drops files on a product row. Shows dropped images at top,
 * channel grids below for sorting. Reuses ProductImagesSubTab.
 */

import { useState } from 'react'
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
  Loading,
} from '@/components/v2/ui'
import { ProductImagesSubTab } from '@/components/products/v2/tabs/assets/ProductImagesSubTab'
import type { ImageSize } from '@/components/products/v2/tabs/assets/types'
import type { QueueImage } from '@/lib/api/image-queue'

interface QuickImageSortPanelProps {
  open: boolean
  onClose: () => void
  productId: string
  productName: string
  uploadedImages: QueueImage[]
  uploading: boolean
}

export function QuickImageSortPanel({
  open,
  onClose,
  productId,
  productName,
  uploadedImages,
  uploading,
}: QuickImageSortPanelProps) {
  const [imageSize, setImageSize] = useState<ImageSize>('S')

  return (
    <Sheet open={open} onOpenChange={(o) => !o && onClose()}>
      <SheetContent
        side="right"
        className="w-full sm:max-w-none sm:w-[60vw] overflow-y-auto flex flex-col p-0"
        showCloseButton
      >
        <SheetHeader className="px-6 pt-6 pb-4 border-b border-neutral-200 dark:border-neutral-700">
          <SheetTitle>Bilder einsortieren</SheetTitle>
          <SheetDescription>{productName}</SheetDescription>
        </SheetHeader>

        <div className="flex-1 overflow-y-auto px-6 py-4">
          {uploading ? (
            <div className="flex items-center justify-center py-12">
              <Loading size="lg" label="Bilder werden hochgeladen..." centered />
            </div>
          ) : (
            <ProductImagesSubTab
              productId={productId}
              imageSize={imageSize}
              setImageSize={setImageSize}
              queueImages={uploadedImages.length > 0 ? uploadedImages : undefined}
            />
          )}
        </div>
      </SheetContent>
    </Sheet>
  )
}
